import {BASE_URL} from 'appConstants';

import {get, post} from 'sdk';

export const fetchRoomNotes = ({roomId, archived}) => {
  const url = `${BASE_URL}/v1/living/room-note/`;

  return get(url, {room: roomId, archived});
};

export const addRoomNote = ({roomId, text}) => {
  const url = `${BASE_URL}/v1/living/room-note/add/`;

  return post(url, {room: roomId, text: text});
};

export const archiveRoomNote = ({note}) => {
  const url = `${BASE_URL}/v1/living/room-note/archive/`;

  return post(url, {note});
};

export const restoreRoomNote = ({note}) => {
  const url = `${BASE_URL}/v1/living/room-note/restore/`;

  return post(url, {note});
};

export const editRoomNote = ({note, text}) => {
  const url = `${BASE_URL}/v1/living/room-note/edit/`;

  return post(url, {note: note, text});
};

export const fetchBookingNotes = ({bookingId, archived}) => {
  const url = `${BASE_URL}/v1/living/booking-notes/`;

  let params = {
    booking: bookingId
  };

  if (archived) {
    params['archived'] = archived;
  }

  return get(url, params);
};

export const addBookingNote = ({text, requiresAction, bookingId}) => {
  const url = `${BASE_URL}/v1/living/booking-notes/create-note/`;

  const payload = {
    booking: bookingId,
    text,
    requiresAction
  };
  return post(url, payload);
};

export const resolveBookingNote = ({noteId}) => {
  const url = `${BASE_URL}/v1/living/booking-notes/resolve-note/`;
  const payload = {bookingNote: noteId};

  return post(url, payload);
};

export const archiveBookingNote = ({note}) => {
  const url = `${BASE_URL}/v1/living/booking-notes/archive-note/`;
  const payload = {
    note
  };
  return post(url, payload);
};

export const restoreBookingNote = ({note}) => {
  const url = `${BASE_URL}/v1/living/booking-notes/restore-note/`;

  const payload = {
    note
  };
  return post(url, payload);
};

export const editBookingNote = ({note, text, requiresAction}) => {
  const url = `${BASE_URL}/v1/living/booking-notes/edit-note/`;

  const payload = {
    text,
    note,
    requiresAction
  };
  return post(url, payload);
};

export const fetchOtherBookingNotes = ({bookingId, archived}) => {
  const url = `${BASE_URL}/v1/living/booking-notes/other-notes/`;

  const params = {
    booking: bookingId
  };

  if (archived) {
    params['archived'] = archived;
  }

  return get(url, params);
};

export const fetchNotes = ({locationRef, extraGetParams}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/notes/`;

  return get(url, extraGetParams);
};

export const fetchBookingOptionsForNotesList = ({locationRef, search}) => {
  const url = `${BASE_URL}/v1/living/${locationRef}/notes/bookings/`;

  return get(url, {search});
};

export const fetchSalesNotes = ({room, archived}) => {
  const url = `${BASE_URL}/v1/living/sales-notes/`;

  return get(url, {room, archived});
};

export const addSalesNote = ({room, requiresAction, text}) => {
  const url = `${BASE_URL}/v1/living/sales-notes/create-note/`;

  const payload = {
    room,
    text,
    requiresAction
  };
  return post(url, payload);
};

export const archiveSalesNote = ({note}) => {
  const url = `${BASE_URL}/v1/living/sales-notes/archive/`;

  return post(url, {note});
};

export const restoreSalesNote = ({note}) => {
  const url = `${BASE_URL}/v1/living/sales-notes/restore/`;

  return post(url, {note});
};

export const resolveSalesNote = ({note}) => {
  const url = `${BASE_URL}/v1/living/sales-notes/resolve/`;

  return post(url, {note});
};

export const editSalesNote = ({note, text}) => {
  const url = `${BASE_URL}/v1/living/sales-notes/edit/`;

  return post(url, {note, text});
};
